import React, { useState, useEffect, useContext } from "react";
import Loading from "../shared/Loading";
import DataGridTableToolbar from "@/utility/DataGridTableToolbar";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import DataGrid from "@/layouts/tables/DataGrid";
import { OrderStatusChit } from "./OrderStatusChit";
import { getTracking } from 'ts-tracking-number';
import { isJaguar } from "@/utility/UserUtils";
import UserContext from "@/context/UserContext";
import { fetchAPI } from "@/utility/NetworkUtils";
import { dhl, fedex, ontrac, s10, ups, usps } from 'ts-tracking-number';

const OrdersTable = ({
  archived = false
}) => {
  const { user } = React.useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders()
  }, [archived])

  fetchOrders = () => {
    setLoading(true)
    fetch(`/webapi/orders?archived=${archived}`)
      .then(response => response.json())
      .then(json => {
        setOrders(json.orders)
        setLoading(false)
      })
  }

  const renderActions = (params) => {
    let actions = [];
   
    actions.push(
      <a href={`/orders/${params.row.id}`}>
        {params.row.status == "draft" || params.row.status == "ready" ? "Edit" : "View"}
      </a>
    )

    if(isJaguar(user)) {
      actions.push(
        <a style={{
          cursor: "pointer"
        }} 
          onClick={() => archiveOrder(params.row.id, archived)}>
          {archived ? "Unarchive" : "Archive"}
        </a>
      )
    }

    return actions
  }

  const archiveOrder = (id, archived) => {
    fetchAPI(`/orders/${id}/${archived ? "unarchive" : "archive"}`,()=> {
      fetchOrders()
    },{
      method: "POST",
    })
  }


  const getColumns = () => {
    return [
      {
        field: "id",
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        headerName: "Order #",
        renderCell: (params) => (<b>{params.value}</b>)
      },
      {
        field: "title",
        flex: 1,
        headerName: "Order Title",
      },
      {
        field: "status",
        flex: 1,
        headerName: "Order Status",
        maxWidth: 120,
        renderCell: (params) => {
          return <OrderStatusChit status={params.value} />
        }
      },
      {
        field:"job_number",
        flex: 1,
        headerName: "Job #",
      },
      {
        field: "arrive_by",
        flex: 1,
        headerName: "Requested Delivery",
        type: "date",
        valueGetter: (arriveBy) => {
          return arriveBy ? new Date(arriveBy+"T08:00-08:00") : null
        },
      },
      // {
      //   field: "arrive_by",
      //   flex: 1,
      //   headerName: "Requested Delivery",
      //   type: "date",
      //   valueGetter: (arriveBy) => {
      //     return arriveBy ? new Date(arriveBy) : null
      //   },
      // },
      {
        field: "order_tracking_numbers",
        flex: 1,
        headerName: "Tracking Numbers",
        valueGetter: ({row: order_tracking_numbers}) => {
          return order_tracking_numbers ? (order_tracking_numbers||[]).map((x) => x.tracking_number).join(", ") : null
        },
        renderCell: ({row: {order_tracking_numbers}}) => {
          console.log("tracking_numbers", order_tracking_numbers)
          return order_tracking_numbers ? (order_tracking_numbers||[]).map((x,i) => renderMultiCell(
            renderTrackingNumber(x)
          )) : null
        },
      },
      {
        field: "order_tracking_numbers_2",
        flex: 1,
        headerName: "Tracking Status",
        valueGetter: ({row: order_tracking_numbers}) => {
          return order_tracking_numbers ? (order_tracking_numbers||[]).map((x) => x.status || "Unavailable").join(", ") : "Unavailable"
        },
        renderCell: ({row: {order_tracking_numbers}}) => {
          console.log("tracking_numbers", order_tracking_numbers)
          return order_tracking_numbers ? (order_tracking_numbers||[]).map((x,i) => renderMultiCell(
            x.status || "Unavailable"
          )) : null
        },
      },
      {
        field: "created_by",
        flex: 1,
        headerName: "Created By",
        valueGetter: (createdBy) => {
          return createdBy ? `${createdBy?.first_name} ${createdBy?.last_name}` : ""
        },
      },
      {
        headerName: "Actions",
        field: "actions",
        type: "actions",
        flex: 1,
        minWidth: 200,
        maxWidth: 250,
        align: "right",
        getActions: renderActions
      }
    ]
  }

  const getTrackingInfo = (trackingNumber) => {
    if(trackingNumber.courier) {
      const trackingCompanyMapping = {
        "ups": ups,
        "fedex": fedex,
        "usps": usps,
        "dhl": dhl,
        "ontrac": ontrac,
      }
      const normalizedCourier = (trackingNumber.courier||"").toLowerCase().replaceAll("-", "").replaceAll(" ", "")
      const currentCourierObject = trackingCompanyMapping[normalizedCourier]
      if(currentCourierObject) {
        return getTracking(trackingNumber.tracking_number, [currentCourierObject])
      }
    }
    return getTracking(trackingNumber.tracking_number)
  }


  const renderTrackingNumber = (trackingNumber) => {
    const trackingInfo = getTrackingInfo(trackingNumber)
    const overrideTrackingUrl = trackingNumber.override_tracking_url
    let url = ""
    if(overrideTrackingUrl && overrideTrackingUrl.length > 0) {
      url = overrideTrackingUrl
    }else {
      url = trackingInfo && trackingInfo.trackingUrl ? trackingInfo.trackingUrl.replace("%s", trackingNumber.tracking_number) : ""
    }
    
    return (
      <div className="sg-tracking-number-div">
        {url ? (
          <a href={url} target="_blank">
            {trackingNumber.tracking_number}
          </a>
        ):(
          trackingNumber.tracking_number
        )}
  
      </div>  
    )
  }
  

  const renderMultiCell = (cell) => {
    return (
      <div>
        {cell}
      </div>
    )
  }

  const getItems = () => {
    return orders.map(x=> {
      x.order_tracking_numbers_2 = x.order_tracking_numbers
      return x
    })
  }

  if(loading) {
    return <Loading />
  }
  return (
    <DataGrid
      tableName="orders"
      unstable_headerFilters
      rows={getItems()}
      columns={getColumns()}
      slots={{
        toolbar: DataGridTableToolbar
      }}
      

      pageSizeOptions={[5, 10, 20, 50, 100]}
    />
  )
};

export default OrdersTable;